import { ApiConfigurationError, CommerceApiName } from '@typesApp/Api'
import { AppErrorType } from '@typesApp/AppError'
import { HostEnvironment } from '@typesApp/Environment'

const DEFAULT_ENDPOINTS = {
  customer: '/wcs/resources/store/{storeId}/person/@self?langId={langId}&storeId={storeId}',
  customerContext: '/wcs/resources/store/{storeId}/usercontext/@self/contextdata?langId={langId}&storeId={storeId}',
  cartItems: '/wcs/resources/store/{storeId}/cart/cartItemDetails?langId={langId}&storeId={storeId}',
} as Record<CommerceApiName, string>

/**
 * @returns empty header if partially authenticated or header with wcToken and wcTrustedToken values
 */
export const getRequestHeaders = (
  isPartiallyAuthenticated: boolean,
  args: { wcToken?: string; wcTrustedToken?: string }
) => {
  return isPartiallyAuthenticated
    ? {}
    : {
        WCToken: args?.wcToken,
        WCTrustedToken: args?.wcTrustedToken,
      }
}

export const getCommerceApiUrl = (environment: HostEnvironment, apiName: CommerceApiName): string => {
  const host = environment?.ecommerceTransactionHost
  const endpoint = DEFAULT_ENDPOINTS[apiName]
  let url = `${host}${endpoint}`
  if (environment.storeId) {
    url = url.replaceAll('{storeId}', environment.storeId)
  }
  if (environment.langId) {
    url = url.replaceAll('{langId}', environment.langId)
  }
  return url
}

export const apiConfigurationError = (
  name: CommerceApiName
): { error: { status: number; data: ApiConfigurationError } } => {
  return {
    error: {
      status: 500,
      data: {
        errorType: AppErrorType.BAD_CONFIGURATION,
        details: `Invalid API configuration - missing action module callback for ${name}`,
      },
    },
  }
}
